import api from '../services/api';
import { IPlan } from './configurations';

export type IPlanPayload = Omit<IPlan, 'id'>;

export const getPlans = async (): Promise<IPlan[]> => {
  const response = await api.get('/plans');
  return response.data;
};

export const createPlan = async (
  payload: Partial<IPlanPayload>,
): Promise<IPlan> => {
  const response = await api.post('/plans', payload);
  return response.data;
};

export const updatePlan = async (
  id: string,
  payload: Partial<IPlanPayload>,
): Promise<IPlan> => {
  const response = await api.patch(`/plans/${id}`, payload);
  return response.data;
};
